import * as Sentry from '@sentry/react';

import localStore from 'utils/extra/localStore';
import logError from 'utils/extra/logError';

const SENTRY_API_KEY = process.env.REACT_APP_SENTRY_APP_ID;

export default function identifyUser() {
  try {
    const retailer = localStore.get('retailer');
    let user = localStore.get('userData') || {};
    if (!user || typeof user !== 'string') {
      return;
    }
    user = JSON.parse(user);
    if (!user || !user.userId) {
      return;
    }

    const { userId, firstName, lastName } = user;

    const userProperties = {
      $first_name: firstName,
      $last_name: lastName,
    };

    if (retailer) {
      userProperties.retailer = retailer;
    }

    if (SENTRY_API_KEY) {
      Sentry.getCurrentScope().setUser({
        id: userId,
        username: `${firstName} ${lastName}`,
      });
    }
  } catch (e) {
    logError(e);
  }
}
